import { debounce } from '@ember/runloop';

import { modifier } from 'ember-modifier';
import $ from 'jquery';

const onReportSlideScrollAndContentChange = (
	node: HTMLElement,
	[callback, debounceTime = 100]: [(node: HTMLElement) => void, number?],
) => {
	const handleEvent = function () {
		debounce(null, callback, node, debounceTime);
	};

	handleEvent();

	node.addEventListener('scroll', handleEvent);
	$(window).on('resize.datawallcenter', handleEvent);

	return () => {
		node.removeEventListener('scroll', handleEvent);
		$(window).off('resize.datawallcenter', handleEvent);
	};
};

const onReportSlideScrollAndContentChangeModifier = modifier(onReportSlideScrollAndContentChange);

export default onReportSlideScrollAndContentChangeModifier;
